angular.module('picmonicng').filter('currentdate', [
  '$filter',
  function ($filter) {
    return function () {
      return $filter('date')(new Date(), 'MM/dd/yyyy');
    };
  },
]);
